module.exports = __webpack_public_path__ + "img/index_pic25.259724aa.png";